import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ApiAnalyticsService } from 'src/app/services/api-analytics.service';
import { URL_IMG, URL_EXT } from '../../constants/general';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  host:{
    'class':'col forms-confirmation-style d-flex justify-content-center first-confirmation-content'
  }
})
export class ConfirmationComponent implements OnInit {

  subsFileOne: Subscription;
  subsFileTwo: Subscription;
  subscription: Subscription;
  form: UntypedFormGroup;
  beneficiaryData:any=[];
  generalData:any=[];
  identificationData:any=[];
  occupationData:any=[];
  proofAddressData:any=[];
  showBeneficiary:boolean=false;
  showOccupation:boolean=false;
  showProofAddress:boolean=false;
  showBeneficiaryAddress:boolean=false;
  img_front = '';
  img_reverse = '';
  img_proof = '';
  imgModal = '';
  url_img = URL_IMG;
  url=URL_EXT;

  constructor(private router:Router,
              private formBuilder:UntypedFormBuilder,
              private api: ApiService,
              private spinner: NgxSpinnerService,
              private data: DataService,
              private modalService: NgbModal,
              private apiAnalytics :ApiAnalyticsService) 
              
  { 
    this.validateSession();
    this.subscribeFile();
    this.buildForm();
  }

  validateSession() {
    if(sessionStorage.getItem('general_data') && sessionStorage.getItem('data_identification') && sessionStorage.getItem('data_occupation') ) {
      this.generalData = JSON.parse( sessionStorage.getItem('general_data') );
      this.identificationData = JSON.parse( sessionStorage.getItem('data_identification') );
      this.occupationData = JSON.parse( sessionStorage.getItem('data_occupation') );

      if(this.occupationData.cx_ocupacion_id == '05' || this.occupationData.cx_ocupacion_id == '01') {
        this.showOccupation=false;
      } else {
        this.showOccupation=true;
      }
      
      if(sessionStorage.getItem('data_beneficiary') && this.occupationData.conBeneficiarios == 'SI') {
        this.beneficiaryData = JSON.parse( sessionStorage.getItem('data_beneficiary') );
        this.showBeneficiary=true;
        if(this.beneficiaryData.mismoDomicilio == "SI") {
          this.showBeneficiaryAddress=false;
        } else {
          this.showBeneficiaryAddress=true;
        }
      } else {
        this.showBeneficiary=false;
      }

      if(sessionStorage.getItem('data_proof_address') && this.identificationData.proof_address == '0') {
        this.proofAddressData = JSON.parse( sessionStorage.getItem('data_proof_address') );
        this.showProofAddress=true;
      } else {
        this.showProofAddress=false;
      }

    } else {
      this.router.navigate(['/registro']);
    }    
  }

  subscribeFile() {
    this.subsFileOne = this.data.fileIDFront.subscribe(file => this.img_front = file);
    this.subsFileTwo = this.data.fileIDBack.subscribe(filetwo => this.img_reverse = filetwo);
    this.subscription = this.data.fileProofAddress.subscribe(filethree => this.img_proof = filethree);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    console.log(this.img_proof);
    this.data.setStep('opciones/autonomo-confirmacion');
  }

  private buildForm() {
    this.form = this.formBuilder.group({
      input: ['1', [Validators.required] ],
    })
  }

  previous(type) {
    console.log(`Autonomo | Paso3 | ${type}Regresar`);
    this.apiAnalytics.gTag(`Autonomo | Paso3 | ${type}Regresar`, 'Autonomo | Paso3', 'Tres Pasos Bursanet','1');
    if(sessionStorage.getItem('data_occupation')) {
      const dataOccupation = JSON.parse( sessionStorage.getItem('data_occupation') );
      if(dataOccupation.conBeneficiarios == 'SI') {
        this.router.navigate(['/opciones/autonomo-beneficiario']);
      } else if(dataOccupation.conBeneficiarios == 'NO') {
        this.router.navigate(['/opciones/autonomo-completa-informacion']);       
      }
    } else {
      this.router.navigate(['/opciones/autonomo-identificacion']);
    }
  }

  gtag(section) {
    console.log(` Autonomo | Paso3 | ${section} | Editar`);
    this.apiAnalytics.gTag(` Autonomo | Paso3 | ${section} | Editar`, 'Autonomo | Paso3', 'Tres Pasos Bursanet','1');
  }

  showImgOne():boolean {    
    if( this.identificationData.cx_formato_identificacion=='image/jpeg' || this.identificationData.cx_formato_identificacion=='image/png') {
      return true;
    } else {
      return false;
    }    
  }

  showPDFOne():boolean {
    if( this.identificationData.cx_formato_identificacion=='application/pdf') {
      return true;
    } else {
      return false;
    }
  }

  showImgTwo():boolean {    
    if( ( this.identificationData.number_files == '2' && this.identificationData.cx_formato_rfc=='image/jpeg') || ( this.identificationData.number_files == '2' && this.identificationData.cx_formato_rfc=='image/png')) {
      return true;
    } else {
      return false;
    }    
  }

  showPDFTwo():boolean {
    if( this.identificationData.number_files == '2' && this.identificationData.cx_formato_rfc=='application/pdf') {
      return true;
    } else {
      return false;
    }
  }

  showImgProof():boolean {    
    if( (this.showProofAddress == true && this.proofAddressData.cx_formato_documento=='image/jpeg') || (this.showProofAddress == true && this.proofAddressData.cx_formato_documento=='image/png')) {
      return true;
    } else {
      return false;
    }    
  }

  showPDFProof():boolean {
    if( this.showProofAddress == true && this.proofAddressData.cx_formato_documento=='application/pdf') {
      return true;
    } else {
      return false;
    }
  }

  openModalFront(content) {
    this.imgModal = this.img_front;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }
  
  openModalReverse(content) {
    this.imgModal = this.img_reverse;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }

  openModalProofAddress(content) {
    this.imgModal = this.img_proof;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    }, (reason) => {      
    });
  }

  saveDataConfirmation(event:Event) {

    event.preventDefault();
    this.form.markAllAsTouched();
    console.log(this.form.valid)

    if(this.form.valid) {
      this.apiAnalytics.gTag(`Autonomo | Paso3 | Continuar`, 'Autonomo | Paso3', 'Tres Pasos Bursanet','1');
      this.saveDataRegister();
    }
  }

  saveDataRegister() {

    this.spinner.show();
    
    const beanCntrtsStep2 = {
      cx_ocupacion: this.occupationData.cx_ocupacion,
      cx_profesion: `${this.occupationData.cx_profesion} | Empresa: ${this.occupationData.nombreEmpresa} | Puesto: ${this.occupationData.puesto} | Beneficiarios: ${this.occupationData.conBeneficiarios}`,
      nombreEmpresa: this.occupationData.nombreEmpresa,
      puesto: this.occupationData.puesto,
      cx_provedor_recursos: 'NO',
      cx_folio: this.generalData.cx_folio,
    };


    const dataProof = this.getDataProofAddress();
    let cx_tipo_domicilio='';
    let cx_contenido_domicilio='';
    let cx_formato_documento='';
    let cx_nombre_documento='';

    if(dataProof) {
      cx_tipo_domicilio = dataProof.cx_tipo_domicilio;
      cx_contenido_domicilio = dataProof.cx_contenido_domicilio;
      cx_formato_documento = dataProof.cx_formato_documento;
      cx_nombre_documento = dataProof.cx_nombre_documento;
    } else {
      cx_tipo_domicilio = '';
      cx_contenido_domicilio = this.identificationData.cx_contenido_identificacion;
      cx_formato_documento = this.identificationData.cx_formato_identificacion;
      cx_nombre_documento = this.identificationData.cx_nombre_identificacion;
    }

    if(this.identificationData.number_files == '1') {
      this.identificationData.cx_nombre_rfc = this.identificationData.cx_nombre_identificacion;
      this.identificationData.cx_formato_rfc = this.identificationData.cx_formato_identificacion;
      this.identificationData.cx_contenido_rfc = this.identificationData.cx_contenido_identificacion;
    }

    const beanCntrtsStep3 = {
      cx_edo_civil: this.occupationData.cx_edo_civil_id,
      cx_tipo_identificacion: this.identificationData.cx_tipo_identificacion,
      cx_tipo_domicilio: cx_tipo_domicilio,
      cx_curp: this.occupationData.cx_curp,
      cx_rfc_tin: this.occupationData.cx_rfc_tin,
      conBeneficiarios: this.occupationData.conBeneficiarios,
      cx_contenido_identificacion: this.identificationData.cx_contenido_identificacion,
      cx_formato_identificacion: this.identificationData.cx_formato_identificacion,
      cx_nombre_identificacion: this.identificationData.cx_nombre_identificacion,
      cx_contenido_curp: this.identificationData.cx_contenido_identificacion,
      cx_formato_curp: this.identificationData.cx_formato_identificacion,
      cx_nombre_curp: this.identificationData.cx_nombre_identificacion,
      cx_contenido_rfc: this.identificationData.cx_contenido_rfc,
      cx_formato_rfc: this.identificationData.cx_formato_rfc,
      cx_nombre_rfc: this.identificationData.cx_nombre_rfc,
      cx_contenido_domicilio: cx_contenido_domicilio,
      cx_formato_documento: cx_formato_documento,
      cx_nombre_documento: cx_nombre_documento,
      cx_nacionalidad: this.generalData.cx_pais,
      cx_folio: this.generalData.cx_folio
    };

    const csrCntrtsEmailBean = {
      email: this.generalData.cx_correo,
      folio: this.generalData.cx_folio,
      nombre_completo: `${this.generalData.cx_nombre} ${this.generalData.cx_apellido_p} ${this.generalData.cx_apellido_m}`,
      num_plantilla: 1
    };


    const body = {
      beanCntrtsStep2 : beanCntrtsStep2, 
      beanCntrtsStep3 : beanCntrtsStep3,
      csrCntrtsEmailBean: csrCntrtsEmailBean
    }

    console.log(body);

    this.api.saveAllSteps(body).subscribe((data: any) => {
      this.spinner.hide();
      console.log(data);
      const dataB = this.buildRequestBeneficiary();
      if(dataB) {
        this.saveBeneficiary(dataB);
      } else {
        this.data.updateFileIDFront('');
        this.data.updateFileIDBack('');
        this.data.updateFileProofAddress('');
        this.apiAnalytics.gTagPixelLargo('#/opciones/autonomo-thank-you-page');
        this.router.navigate(['/opciones/autonomo-thank-you-page']);
        this.prospectClientRegistration();
      }
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

  saveBeneficiary(dataB) {
    this.spinner.show();
    this.api.addBeneficiary(dataB).subscribe((data: any) => {
      this.spinner.hide();
      this.data.updateFileIDFront('');
      this.data.updateFileIDBack('');
      this.data.updateFileProofAddress('');
      this.apiAnalytics.gTagPixelLargo('#/opciones/autonomo-thank-you-page');
      this.router.navigate(['/opciones/autonomo-thank-you-page']);
      this.prospectClientRegistration();  
    }, error => {    
      this.spinner.hide();
      this.data.updateFileIDFront('');
      this.data.updateFileIDBack('');
      this.data.updateFileProofAddress('');
      this.apiAnalytics.gTagPixelLargo('#/opciones/autonomo-thank-you-page');
      this.router.navigate(['/opciones/autonomo-thank-you-page']);
      this.prospectClientRegistration();
      console.log('Error: ', error);
    });
  }

  getDataProofAddress():any {
    if(sessionStorage.getItem('data_proof_address') && this.identificationData.proof_address == '0') {
      let data = JSON.parse( sessionStorage.getItem('data_proof_address') );
      return data;
    } else {
      return false;
    }    
  }

  buildRequestBeneficiary():any {

    if( sessionStorage.getItem('data_beneficiary') && this.showBeneficiary == true) {     
      let dataBeneficiary = JSON.parse( sessionStorage.getItem('data_beneficiary') ); 
      let delegacion = (dataBeneficiary.mismoDomicilio == 'NO') ? dataBeneficiary.delegacion+'-'+dataBeneficiary.delegacionVal : '';
      dataBeneficiary.mismoDomicilio = (dataBeneficiary.mismoDomicilio == 'NO') ? "mismoBnfcr2" : "mismoBnfcr1";    

      let data = {
        nombre:dataBeneficiary.nombre,
        aPaterno:dataBeneficiary.aPaterno,
        aMaterno:dataBeneficiary.aMaterno,
        parentescoTxt:dataBeneficiary.parentescoTxt,
        parentescoVal:dataBeneficiary.parentescoVal,
        fechaNacBnfcrDD:dataBeneficiary.fechaNacBnfcrDD,
        fechaNacBnfcrMM:dataBeneficiary.fechaNacBnfcrMM,
        fechaNacBnfcrYYYY:dataBeneficiary.fechaNacBnfcrYYYY,
        fechaNacimientoBnfcrDp:dataBeneficiary.fechaNacimientoBnfcrDp,
        mismoDomicilio:dataBeneficiary.mismoDomicilio,
        tipoDomicilioVal:dataBeneficiary.tipoDomicilioVal,
        tipoDomicilioTxt:dataBeneficiary.tipoDomicilioTxt,
        codigoPostal:dataBeneficiary.codigoPostal,
        numeroInt:dataBeneficiary.numeroInt,
        numeroExt:dataBeneficiary.numeroExt,
        paisVal:dataBeneficiary.paisVal,
        paisTxt:dataBeneficiary.paisTxt,
        estado:dataBeneficiary.estadoVal,
        ciudad:dataBeneficiary.ciudad,
        ciudadTxt:dataBeneficiary.ciudadTxt,
        delegacion:delegacion,
        colonia:dataBeneficiary.coloniaVal,
        calle:dataBeneficiary.calle,  
        porcentajeBnfcr:'100',
        idFolio:this.generalData.cx_folio,  
        razonSocial:'',
        tipoDePersona:'tipoBnfcr2',  
        tipoComprobanteDomVal:'-1',
        tipoComprobanteDomTxt:'SELECCIONAR'    
      }
  
      return data;

    } else {
      return false;
    }    
  }

  prospectClientRegistration() {
    this.spinner.show();

    this.api.getToken().subscribe((dataToken: any) => {
      let recordTypeId = '0122C0000001F1nQAE';
      if(window.location.origin.indexOf("bursanet.mx") == 12) {
        recordTypeId = '0125e000000OdVvAAK';
      }
      let dom_Actual__c = 'true';
      let dataAddress:any;
      if( sessionStorage.getItem('data_proof_address') ) {
        dom_Actual__c = 'false';
        dataAddress = JSON.parse( sessionStorage.getItem('data_proof_address') ); 
      }

      let beneficiary:any;
      if( sessionStorage.getItem('data_beneficiary') && this.showBeneficiary == true) {
        const dataBeneficiary = JSON.parse( sessionStorage.getItem('data_beneficiary') );
        beneficiary = {
          adressTypeB__c: dataBeneficiary.tipoDomicilioTxt,
          apellido_MaternoB__c:dataBeneficiary.aMaterno,
          birthdateB__c: dataBeneficiary.fechaNacimientoBnfcrDp,
          calleB__c: dataBeneficiary.calle,
          cityB__c: dataBeneficiary.ciudadTxt,
          colB__c: dataBeneficiary.colonia,
          countryB__c: dataBeneficiary.paisTxt,
          enb__c: dataBeneficiary.numeroExt,
          firstNameB__c: dataBeneficiary.nombre,
          inb__c: dataBeneficiary.numeroInt,
          lastNameB__c: dataBeneficiary.aPaterno,
          municipioB__c: dataBeneficiary.delegacion,
          parentesco__c:dataBeneficiary.parentescoTxt,
          pcb__c: dataBeneficiary.codigoPostal,
          stateB__c: dataBeneficiary.estado,
          adressB__c: dataBeneficiary.mismoDomicilio
        }
      } else {
        beneficiary = {
          adressTypeB__c: "",
          apellido_MaternoB__c:"",
          birthdateB__c: "",
          calleB__c: "",
          cityB__c: "",
          colB__c: "",
          countryB__c: "",
          enb__c: "",
          firstNameB__c: "",
          inb__c: "",
          lastNameB__c: "",
          municipioB__c: "",
          parentesco__c:"",
          pcb__c: "",
          stateB__c: "",
          adressB__c: ""
        }
      }

      let bodyProspect = {
        "adressB__c": beneficiary.adressB__c,
        "adressTypeB__c":  beneficiary.adressTypeB__c,
        "apellido_Materno__c": this.generalData.cx_apellido_m,
        "apellido_MaternoB__c": beneficiary.apellido_MaternoB__c,
        "asistencia__c": "false",
        "birthdateB__c": beneficiary.birthdateB__c,
        "calleB__c": beneficiary.calleB__c,
        "cityB__c":  beneficiary.cityB__c,
        "colB__c": beneficiary.colB__c,
        "company": this.occupationData.nombreEmpresa,
        "countryB__c":  beneficiary.countryB__c,
        "curp__C": this.occupationData.cx_curp,
        "document__c": this.identificationData.cx_tipo_identificacion_txt,
        "dom_Actual__c": dom_Actual__c,
        "email": this.generalData.cx_correo,
        "enb__c":  beneficiary.enb__c,
        "estado_Civil__c": this.occupationData.cx_edo_civil,
        "firstName": this.generalData.cx_nombre,
        "firstNameB__c": beneficiary.firstNameB__c,
        "folio__c": this.generalData.cx_folio,
        "inb__c":  beneficiary.inb__c,
        "lastName": this.generalData.cx_apellido_p,
        "lastNameB__c": beneficiary.lastNameB__c,
        "leadSource": "BURSANET",
        "municipioB__c": beneficiary.municipioB__c,
        "parentesco__c":  beneficiary.parentesco__c,
        "pcb__c": beneficiary.pcb__c,
        "pdr__c": "false",
        "postalCode": "00000",
        "profesion__c": this.occupationData.cx_ocupacion,
        "profesion_esp__c": this.occupationData.cx_profesion,
        "puesto__c": this.occupationData.puesto,
        "recordTypeId": recordTypeId,
        "rfc__C": this.occupationData.cx_rfc_tin,
        "stateB__c": beneficiary.stateB__c,
        "status": "true"
      };

      this.api.prospectClientRegistration(bodyProspect, dataToken.accessToken, this.generalData.int_telefono).subscribe((data: any) => {
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        console.log('Error: ', error);
      });
    }, error => {
      this.spinner.hide();
      console.log('Error: ', error);
    });
  }

}
